import i18n from 'i18next';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { flattenKeys, nestKeys } from '@/utils/translations';

// Syncs CDN translations from the react-intl adapter into i18next so that
// components still using useTranslation receive the correct language without
// needing to be individually migrated to useFormat.
export const useI18nBridge = () => {
  const { locale, messages } = useIntl();

  useEffect(() => {
    const lang = locale.split('-')[0];
    const byNamespace: Record<string, Record<string, string>> = {};

    Object.entries(flattenKeys(messages as Record<string, unknown>))
      .filter(([key]) => key.includes('.'))
      .forEach(([fullKey, value]) => {
        const key = fullKey.startsWith('parachute-ui.') ? fullKey.slice('parachute-ui.'.length) : fullKey;
        const [ns, ...rest] = key.split('.');
        if (!byNamespace[ns]) byNamespace[ns] = {};
        byNamespace[ns][rest.join('.')] = value;
      });

    Object.entries(byNamespace).forEach(([ns, flat]) => {
      i18n.addResourceBundle(lang, ns, nestKeys(flat), true, true);
    });

    i18n.changeLanguage(lang);
  }, [locale, messages]);
};
